/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the kind of user in the system
 */
export enum UserKind {
    PERSON = 'person',
    SYSTEM = 'system',
}
